// ControlEvidenceTab — evidence attached to the current control.
// Thin wrapper around the shared EvidenceTab component.

import { useParams } from '@tanstack/react-router'
import { useApi } from '@/lib/api/client'
import { useTenant } from '@/components/shared/TenantShell'
import { controlsApi } from '@/lib/api/controls'
import { queryKeys } from '@/lib/api/queryKeys'
import { EvidenceTab } from '@/components/features/evidence'
import { useAuth } from 'react-oidc-context'

export function ControlEvidenceTab() {
  const { slug } = useTenant()
  const { controlId } = useParams({ strict: false }) as { controlId: string }
  const api = useApi()
  const auth = useAuth()
  const ctrlApi = controlsApi(api)

  return (
    <EvidenceTab
      queryKey={queryKeys.controls.evidence(slug, controlId)}
      fetchFn={(includeArchived) => ctrlApi.evidence(controlId, includeArchived)}
      uploadFn={(params) =>
        ctrlApi.uploadEvidence(controlId, {
          file: params.file,
          evidenceTagId: params.evidenceTagId,
          comment: params.comment,
        })
      }
      downloadFn={(url) =>
        fetch(url, {
          headers: { Authorization: `Bearer ${auth.user?.id_token ?? ''}` },
        })
      }
      archiveFn={(evidenceId) => ctrlApi.archiveEvidence(controlId, evidenceId)}
      entityNoun="control"
    />
  )
}
